export enum STORAGE_KEYS {
  AUTH_TOKEN = 'store:AUTH_TOKEN',
  NORA_AUTH_TOKEN = 'store:NORA_AUTH_TOKEN',
}

export const StorageDefaultValues = {
  [STORAGE_KEYS.AUTH_TOKEN]: '',
  [STORAGE_KEYS.NORA_AUTH_TOKEN]: '',
}

export function setStorageItem<K extends STORAGE_KEYS>(id: K, value: typeof StorageDefaultValues[K]): boolean {
  if (typeof window !== 'undefined') {
    window?.localStorage?.setItem(id, value)
    return true
  }
  return false
}

export function getStorageItem<K extends STORAGE_KEYS>(id: K): typeof StorageDefaultValues[K] {
  if (typeof window !== 'undefined' && window.localStorage) {
    return <any>window?.localStorage?.getItem(id) || null
  }
  return null
}
